import type { ChartsTrackStatus } from '~/types/ChartsTrackStatus'
import type { CoreFetch } from '~/types/CoreFetch'

/**
 * The Track Charts upsell could've been refunded by this point. Use `hasTrackChartsRankWithNonRefundedStatus` to typeguard for a non refunded charts upsell.
 */
type FetchTrackChartsRank = {
  rank: null | number
  status: ChartsTrackStatus | 'refunded'
}

type NonRefundedFetchTrackChartsRank = {
  rank: null | number
  status: ChartsTrackStatus
}

type MissingFetchTrackChartsRank = {
  rank: null
  status: null
}

export type FetchTrackChartsRankResponse =
  | MissingFetchTrackChartsRank
  | FetchTrackChartsRank

export function hasTrackChartsRankStatus(
  response: FetchTrackChartsRankResponse,
): response is FetchTrackChartsRank {
  return response.status !== null
}

export function hasTrackChartsRankWithNonRefundedStatus(
  response: FetchTrackChartsRankResponse,
): response is NonRefundedFetchTrackChartsRank {
  return hasTrackChartsRankStatus(response) && response.status !== 'refunded'
}

export function provideFetchTrackChartsRank(coreFetch: CoreFetch) {
  /**
   * Fetch the rank of the given track in "Groover Charts".
   *
   * @param trackId - The ID of the track to fetch the rank for.
   * @returns The charts rank of the track (`number` if in charts, `null` if the track has fallen off) or returns a 404 if the track has not paid for charts
   */
  return function fetchTrackChartsRank(trackId: number) {
    return coreFetch.$get<FetchTrackChartsRankResponse>(
      `/track/track/${trackId}/chart/`,
    )
  }
}
